import { render, staticRenderFns } from "./ManagementUserProfiles.vue?vue&type=template&id=60c6151a&"
import script from "./ManagementUserProfiles.vue?vue&type=script&lang=js&"
export * from "./ManagementUserProfiles.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports